export default {"src":"/_next/static/media/HomeIcon.7d1bee3e.svg","height":18,"width":17};